import GoogleMapReact, { Coords } from 'google-map-react';
import { MapContainer, TileLayer, Marker, Popup, Circle  } from 'react-leaflet'
import React, { FC, useEffect, useState } from 'react';
import ErrorBoundary from '../error-boundary/error-boundary.component';

import L from 'leaflet';

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

type Props = {
	width?: string | number;
	height?: string | number;
	location: Coords;
	disableInteraction?: boolean; //draggable on maps prop
	radius?: number; //if radius is supplied it will draw a circle not a marker
	type: 'GPS' | 'SLEEPER';
};

export const Map: FC<Props> = ({ width, height, location, disableInteraction, radius, type }) => {

	const [position, setPosition] = useState<Coords>();
	const [loading, setLoading] = useState<boolean>(true);

	const getPosition = async () => {
		navigator.geolocation.getCurrentPosition(pos => {
			setPosition({ lat: pos.coords.latitude, lng: pos.coords.longitude })
		}, err => {
			alert(err.message);
		}, {
			enableHighAccuracy: true
		})
	}

	useEffect(() => {
		const usePosition = type === 'GPS';
		if (usePosition) {
			getPosition();
		} else {
			setLoading(false);
		}
	}, [type])

	useEffect(() => {
		if (position) { 
			setLoading(false);
		}
	}, [position])
	
	return (
		<div className="rounded-xl bg-gray-100" style={{ height: height || 200, width: width || '100%' }}>
			<ErrorBoundary>
				{
					loading
					?
					<div className='flex justify-center items-center h-full'>
						<h3>Loading map...</h3>
					</div>
					:
<MapContainer center={[location.lat, location.lng]} zoom={13} >
  
  <TileLayer
    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
   />
{type === 'SLEEPER' ? (
       <Circle center={[location.lat, location.lng]} radius={1000}/>
      ) : (
        <Marker position={[location.lat, location.lng]} ></Marker>
      )}
  
</MapContainer>
				}

			</ErrorBoundary>
		</div >
	);
};
